import React, { useEffect } from 'react';
import { Typography, Breadcrumbs, Grid, Tooltip, IconButton } from '@material-ui/core';
import { Link, useLocation, withRouter } from "react-router-dom";
import withBreadcrumbs from 'react-router-breadcrumbs-hoc';
import PropTypes from 'prop-types';
import DocumentMeta from 'react-document-meta';
import { LocalLibrary } from '@material-ui/icons';
import { useTour } from '@reactour/tour';
import { RecordMostUsedPageButton } from './RecordMostUsedPage';

var itemArr = sessionStorage.getItem("items") ? JSON.parse(sessionStorage.getItem("items")) : new Array();
/**
 * 麵包屑
 * @param {object} sidebarRes json
 * @param {object} location obj
 */
class RouterBreadcrumb extends React.Component {
    constructor(props) {
        super(props);
        this.state = {};
    }

    render() {
        let GResult = this.props.sidebarRes.children; // json
        let locatPath = window.location.pathname.split('/').filter((x) => x !== "");
        let group = locatPath[0], page = locatPath[1];
        let g = GResult.find((item) => item.code === group);
        if (g == undefined) {
            return (<div></div>);
        }
        let p = g.children.find((item) => item.code === page);
        if (g !== undefined && p !== undefined) {
            //直接取代
            itemArr = [g, p];
            sessionStorage.setItem('items', JSON.stringify(itemArr));
            //移除頁碼的紀錄
            // sessionStorage.removeItem("nowPage");
            // sessionStorage.removeItem("rowsPerPage");
        } else {
            //判斷陣列是否已經有當前頁面
            let now_page = itemArr.find((item) => item.code === page);
            if (now_page !== undefined) {
                let finalArr = new Array();
                for (let i = 0; i < itemArr.length; i++) {
                    let item = itemArr[i];
                    if (item.code !== page) {
                        finalArr.push(item);
                    } else {
                        finalArr.push(item);
                        break;
                    }
                }
                sessionStorage.setItem('items', JSON.stringify(finalArr));
            } else {
                // 加入
                GResult.forEach(item => {
                    // 群組
                    if (item.code === group) {
                        item.children.forEach((ite) => {
                            // 第二層
                            if (ite.code !== "" && ite.code === page) {
                                itemArr.push(ite);
                            } else {
                                // 第三層
                                ite.children.forEach((it) => {
                                    if (it.code !== "" && it.code === page) {
                                        itemArr.push(it);
                                    }
                                })
                            }
                        })
                    }
                })
                sessionStorage.setItem('items', JSON.stringify(itemArr));
            }
        }
        let breakException = sessionStorage.items === undefined || sessionStorage.items === "undefined" ? [] : JSON.parse(sessionStorage.items);

        //META TITLE 用
        let items = JSON.parse(sessionStorage.getItem("items"));
        let companyName = sessionStorage.company_code;
        if (companyName == null) {
            companyName = "ESD";
        } else {
            companyName = companyName + (sessionStorage.home_page_name != undefined && sessionStorage.home_page_name != "" ? " - " + sessionStorage.home_page_name : "");
        }
        let pageName = "";
        if (items != null && items.length > 0) {
            pageName = " - " + items[0].name
        } else {
            console.warn("ESD Error! items 沒有內容，無法比對", items)
            console.warn("g: ", g);
            console.warn("p: ", p);
        }
        const meta = {
            meta: {
                // ex: name 標籤名稱, obj裡 google 次要標籤名稱, notranslate 次要標籤值
                name: {
                    google: 'notranslate',
                    viewport: "width=device-width, initial-scale=1"
                }
            },
            title: companyName + pageName + (window.location.host.indexOf("test") > -1 ? "(測試)" : (window.location.host.indexOf("localhost") > -1 ? "(本機)" : ""))
        }

        let prevPathName = "";
        return (
            <React.Fragment>
                <DocumentMeta {...meta} />
                <Breadcrumbs aria-label="breadcrumb" className="Breadcrumbs">

                    {(sessionStorage.home_page_name != undefined && sessionStorage.home_page_name != "") ?
                        <Typography color="textPrimary" key={pageName}>
                            {sessionStorage.home_page_name}
                        </Typography>
                        : null
                    }
                    {breakException.map((item, index) => {
                        if (index > 0) {
                            prevPathName = breakException[index - 1].name;
                        }
                        return (index === 0) ?
                            ( // 判斷 是不是群組 ?
                                <Typography color="textPrimary" key={item.pg_id}>
                                    {item.name}
                                </Typography>
                            ) :
                            ( // 判斷 是不是跟前一個名稱相同 ?
                                (prevPathName == item.name) ? null :
                                    ( // 判斷 是不是最後一頁 ?
                                        (index !== breakException.length) ?
                                            <Link color="inherit" to={{ pathname: item.path, state: this.props.location.state }} key={item.page_id}>
                                                {item.name}
                                            </Link> :
                                            <Typography color="textPrimary" key={item.page_id}>
                                                {item.name}
                                            </Typography>
                                    )
                            );
                    })}

                    <Grid style={{
                        position: 'absolute', right: '16px', top: '50%', transform: "translateY(-50%)", margin: "0 1rem",
                        display: 'flex', flexDirection: 'row', gap: '24px'
                    }}>
                        <RecordMostUsedPageButton />
                        <ReactTourStartButon />
                    </Grid>
                </Breadcrumbs>
            </React.Fragment>
        )
    }
}
/**
 * RouterBreadcrumb
 * @description 型別判斷
 */
RouterBreadcrumb.propTypes = {
    sidebarRes: PropTypes.object,
    location: PropTypes.object,
}

/**@description 導覽教學開啟按鈕 */
function ReactTourStartButon() {
    /**@description 引入導覽相關hook */
    const { setIsOpen, setCurrentStep, setSteps, steps, } = useTour();
    const location = useLocation();

    // URL改變時即預先清空steps
    useEffect(() => {
        setSteps([])
    }, [location]);

    return <React.Fragment>
        {steps.length > 0
            ? <Tooltip
                placement="bottom"
                title={"開啟導覽教學"}
                arrow={true}
                data-aria="simple">
                <IconButton
                    className="tourBtn"
                    size="small" color="primary"
                    onClick={() => { setCurrentStep(0); setIsOpen(true) }}
                >
                    <LocalLibrary />
                </IconButton>
            </Tooltip>
            : null}
    </React.Fragment>
}


export default withRouter(withBreadcrumbs()(RouterBreadcrumb));
